const DARK = '#0f172a';
const LIGHT = '#ffffff';

function luminance(hex: string): number {
  // '#fff' is #ffffff: read as six digits it is a dark blue, and white pins got white numbers.
  const raw = hex.replace('#', '');
  const n = parseInt(raw.length === 3 ? raw.split('').map(c => c + c).join('') : raw, 16);
  const [r, g, b] = [n >> 16, (n >> 8) & 255, n & 255].map(v => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrast(a: string, b: string): number {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

/** White or near-black, whichever reads better on `fill` (a day's colour can be a pale yellow). */
export function textOn(fill: string): string {
  return contrast(fill, LIGHT) >= contrast(fill, DARK) ? LIGHT : DARK;
}

/** The day's colour when it reads on `background` (≥ 3:1, large/bold text); otherwise `fallback`. */
export function toneOn(tone: string, background: string, fallback: string): string {
  return contrast(tone, background) >= 3 ? tone : fallback;
}
